export interface Organization {
  // mock data
  id: number;
  nameEn: string;
  nameTh: string;
  organizations?: Organization[];

  // real data
  _id: string;
  name: string;
  taxId: string;
  businessType: string;
  businessTypeEn: string;
  businessTypeTh: string;
  orgProfile?: string;

  // PCAF classification — present for SSO-provisioned borrowers, null for everyone else
  orgType?: "borrower" | "lender" | null;
  listingStatus?: ListingStatus | null;
  // TSIC and ISIC are parallel classifications; the bank re-slices its portfolio by either
  sectorTsic?: SectorRef | null;
  sectorIsic?: SectorRef | null;
  // Absent until the backend sends it; null per field means nobody is recorded as having set it.
  classificationSource?: ClassificationSource;
}

export type ClassificationSourceValue = "bank" | "borrower";

export interface ClassificationSource {
  sectorIsic: ClassificationSourceValue | null;
  sectorTsic: ClassificationSourceValue | null;
  listingStatus: ClassificationSourceValue | null;
}

export type ListingStatus = "listed" | "unlisted";

export interface SectorRef {
  code: string;
  nameEn: string;
  nameTh: string;
  level: number;
}

// Shared by the onboarding wizard and the Org Profile card, so both show a value the same way.
export const sectorRefLabel = (sector: SectorRef, language: string) =>
  `${sector.code} — ${language.includes("th") ? sector.nameTh : sector.nameEn}`;

export const LISTING_STATUS_LABEL_KEY: Record<ListingStatus, string> = {
  listed: "Onboarding-Form-Listing-Status-Listed",
  unlisted: "Onboarding-Form-Listing-Status-Unlisted",
};
